import { render, staticRenderFns } from "./Debitos.vue?vue&type=template&id=2f8591fc&"
import script from "./Debitos.vue?vue&type=script&lang=js&"
export * from "./Debitos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports